import * as React from "react";
const SvgMoreVertical20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M10 2.333A1.833 1.833 0 1 0 10 6a1.833 1.833 0 0 0 0-3.667Zm0 5.834a1.833 1.833 0 1 0 0 3.666 1.833 1.833 0 0 0 0-3.666ZM10 14a1.833 1.833 0 1 0 0 3.667A1.833 1.833 0 0 0 10 14Z",
      clipRule: "evenodd"
    })
  );
export default SvgMoreVertical20Px;
